import React, { useState, useEffect } from 'react'
import { Bank } from '../../../models/bankAccount'
import errorAlert from '../../../assets/images/error-alert.svg'

interface PaymentComponentProps {
  paymentMode: string
  branchCode: string
  banks: Bank[]
  defaultBankCode?: string
  defaultAccount?: string
  onToFindPayInBankTypeSelect: (payInBankType: string) => void
  onBankCodeSelect: (bankCode: string) => void
  onAccountSelect: (account: string) => void
  isRequireBank: boolean
  isRequireAccountNo: boolean
  disabled?: boolean
}

const BankAccountComponent: React.FC<PaymentComponentProps> = ({
  paymentMode,
  branchCode,
  banks,
  defaultBankCode = '',
  defaultAccount = '',
  onToFindPayInBankTypeSelect,
  onBankCodeSelect,
  onAccountSelect,
  isRequireBank,
  isRequireAccountNo,
  disabled
}) => {
  const [selectedBankCode, setSelectedBankCode] = useState<string>(defaultBankCode)
  const [selectedAccount, setSelectedAccount] = useState<string>(defaultAccount)

  const handleBankCodeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const bankCode = event.target.value
    setSelectedBankCode(bankCode)
    setSelectedAccount('')
    onBankCodeSelect(bankCode)
  }

  const handleAccountChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const account = event.target.value
    setSelectedAccount(account)
    onAccountSelect(account)
    //onToFindPayInBankTypeSelect(account)
  }

  return (
    <div>
      <div>
        <span className="amount-text">รายละเอียดการนำฝากเข้าธนาคาร</span>
        <select
          id="banks"
          onChange={handleBankCodeChange}
          value={selectedBankCode}
          className={`select-input ${isRequireBank && 'error-border-validate'}`}
          disabled={disabled}
        >
          <option value="">เลือก</option>
          {banks.map((bank, index) => (
            <option key={index} value={bank.bankCode}>
              {bank.bankName}
            </option>
          ))}
        </select>
        {isRequireBank && (
          <div className="error-text-validate">
            <img src={errorAlert} alt="ErrorAlert" />
            กรุณากรอกข้อมูล
          </div>
        )}
      </div>

      {
        <div>
          <span className="amount-text">เลขที่บัญชี </span>
          <select
            id="accounts"
            onChange={handleAccountChange}
            value={selectedAccount}
            disabled={disabled}
            className={`select-input ${isRequireAccountNo && 'error-border-validate'}`}
          >
            <option value="">เลือก</option>
            {banks
              .find(bank => bank.bankCode === selectedBankCode)
              ?.accountNumbers.map((account, index) => (
                <option key={index} value={account}>
                  {account}
                </option>
              ))}
          </select>
          {isRequireAccountNo && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
      }
    </div>
  )
}

export default BankAccountComponent
